import { Grid, makeStyles } from '@material-ui/core';
import BeforeIcon from '@material-ui/icons/NavigateBefore';
import NextIcon from '@material-ui/icons/NavigateNext';
import Button from 'components/Button';
import i18n from 'i18n';
import React from 'react';

import { connect } from 'react-redux';
import ApplicationState from 'store/interfaces';
import clsx from 'clsx';
import { CompanyData, RolesEnum } from 'modules/authenticate/interfaces';
import { inAdminView, inSuperAdminView, inOperatorView } from 'utils/role';
import styles from '../Template/styles';

const useStyles = makeStyles(styles);

interface Props {
  companySelected: CompanyData | null;
  disableSave?: boolean;
  disableNextStep?: boolean;
  role?: RolesEnum;
  saveLoading?: boolean;
  onCancel?: () => void;
  onSave?: () => void;
  onPrevStep?: () => void;
  onNextStep?: () => void;
}

const ActionButtons = ({
  companySelected,
  disableSave,
  disableNextStep,
  role,
  saveLoading,
  onCancel,
  onNextStep,
  onPrevStep,
  onSave,
}: Props) => {
  const classes = useStyles();

  return (
    <React.Fragment>
      <Grid
        container
        justify="space-between"
        className={classes.buttons}
        style={{ margin: '40px 0 0' }}
      >
        <span>
          {onPrevStep && (
            <Button
              variant="contained"
              color="secondary"
              className={clsx({
                [classes.addButtonGreen]: inAdminView(role, companySelected),
                [classes.addButtonGray]: inSuperAdminView(
                  role,
                  companySelected
                ),
                [classes.addButtonBlue]: inOperatorView(role, companySelected),
                [classes.addButtonYellow]: companySelected,
              })}
              startIcon={<BeforeIcon />}
              onClick={onPrevStep}
            >
              {i18n.t('PREVIOUS_KEY')}
            </Button>
          )}
        </span>
        <span>
          {onSave && (
            <Button
              id="submit-button"
              onClick={onSave}
              isLoading={saveLoading}
              disabled={disableSave}
              submitButton
            >
              {i18n.t('SAVE_KEY')}
            </Button>
          )}
          {onCancel && (
            <Button id="cancel-button" variant="outlined" onClick={onCancel}>
              {i18n.t('CANCEL_KEY')}
            </Button>
          )}
        </span>

        <span>
          {onNextStep && (
            <Button
              variant="contained"
              color="secondary"
              className={clsx({
                [classes.addButtonGreen]: inAdminView(role, companySelected),
                [classes.addButtonGray]: inSuperAdminView(
                  role,
                  companySelected
                ),
                [classes.addButtonBlue]: inOperatorView(role, companySelected),
                [classes.addButtonYellow]: companySelected,
              })}
              endIcon={<NextIcon />}
              onClick={onNextStep}
              disabled={disableNextStep}
            >
              {i18n.t('NEXT_KEY')}
            </Button>
          )}
        </span>
      </Grid>
    </React.Fragment>
  );
};

const mapStateToProps = ({
  authenticate: { companySelected, data },
}: ApplicationState) => ({
  companySelected,
  role: data?.role,
});

export default connect(mapStateToProps, {})(ActionButtons);
